const HTTP_SSO_USER_CHANGED_STATUS = 333;

export function artifactoryUserChangedInterceptor(ArtifactoryState, $q) {

    function request(req) {
        return req;
    }

    function response(res) {
        handleResponse(res);
        return res;
    }

    function responseError(res) {
        handleResponse(res);
        return $q.reject(res);
    }

    function handleResponse(res) {
        if (res.status === HTTP_SSO_USER_CHANGED_STATUS) {
            window.store.dispatch('USER_CHANGED');
        }
        return res;
    }

    return {
        response: response,
        request: request,
        responseError: responseError
    };
}



// WEBPACK FOOTER //
// ./services/artifactory_user_changed_interceptor.js